import { render, staticRenderFns } from "./ReservationQueue.vue?vue&type=template&id=06192e22"
import script from "./ReservationQueue.vue?vue&type=script&lang=js"
export * from "./ReservationQueue.vue?vue&type=script&lang=js"
import style0 from "./ReservationQueue.vue?vue&type=style&index=0&id=06192e22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports